/*!
 * Local Project Js File
 *
 */

window.requestAnimFrame = (function(){
  return  window.requestAnimationFrame       ||
          window.webkitRequestAnimationFrame ||
          window.mozRequestAnimationFrame    ||
          window.oRequestAnimationFrame      ||
          window.msRequestAnimationFrame     ||
          function( callback ){
            window.setTimeout(callback, 1000 / 60);
          };
})();

(function () {

  "use strict";

  var myApp = {

  }

  myApp.init = function() {

    var ticking = false;
    var last_known_scroll_position;
    var headerFixed = $('.navbar-fixed-top');


    ruralApp.Flexslider.initFlex('.flexslider', {
      animation: 'fade',
      slideshowSpeed: 6000,
      animationSpeed: 1200,
      directionNav: false
    });
    ruralApp.MagnificPopup.initMagnific('.gallery', {delegate: 'a', type: 'image', gallery: { enabled:true }});


    if (location.pathname == "/app_dev.php/mercados" || location.pathname == "/mercados") {
      var smoothScrollItem = $('.navbar-nav').find('.smooth-scroll');
      smoothScrollItem.off('click', smoothScroll,false);
      smoothScrollItem.on('click', function(event) {
        event.preventDefault();
        window.location = '/' + this.hash;
      });
    } else {
      $('body').scrollspy({ target: '#main-nav', offset: headerFixed.outerHeight(true) });
    }

    $('.gallery-item>a').magnificPopup({
      type: 'image',
      gallery: {
        enabled: true
      }
    });
  }




  document.addEventListener('DOMContentLoaded', function() {
    myApp.init();
  }, false);

})();
